const getRealtimeApiUrl = (parentUrl) => {
	if (parentUrl.includes('localhost:3000')) {
		return 'http://localhost:5009';
	}

	if (parentUrl.includes('staging-') || parentUrl.includes('myreviewlogin')) {
		return 'https://staging-realtime.chekkit.io';
	}

	if (parentUrl.includes('evanov') || parentUrl.includes('radio')) {
		return 'https://realtime2.chekkit.io';
	}

	return 'https://realtime.chekkit.io';
};

export default getRealtimeApiUrl;
